/**
 * 白名单设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WhiteMenuManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;

   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;

   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region whitemenu 白名单设置接口
  /**
   * 查询白名单信息
   * @param param
   * @returns {Observable<any>}
   */
  queryWhiteMenuById(param) {
    const url = this.prefix + 'white/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 新增白名单
   * @param param
   * @returns {Observable<any>}
   */
  saveWhiteMenu(param) {
    const url = this.prefix + 'white/save';
    return this.http.Post(url, param);
  }

  /**
   * 修改白名单
   * @param param
   * @returns {Observable<any>}
   */
  updateWhiteMenu(param) {
    const url = this.prefix + 'white/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除白敏单
   */
  deleteWhiteMenu(param) {
    const url = this.prefix + 'white/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 获取白名单权限列表
   * @param param
   * @returns {Observable<any>}
   */
  getWhiteControlList(whiteId, systemId) {
    const url = this.prefix + 'whiteControl/queryByWhiteId?whiteId=' + whiteId + '&systemId=' + systemId;
    return this.http.Post(url, null);
  }

  /**
   * 给白名单添加权限
   * @param param
   * @returns {Observable<any>}
   */
  saveControl(param) {
    const url = this.prefix + 'whiteControl/saveOrDelete';
    return this.http.Post(url, param);
  }

 //#endregion

}
